import React from "react"
import PropTypes from "prop-types"
class WebSetting extends React.Component {
  render () {
    return (
      <React.Fragment>
        Rules: {this.props.rules}
      </React.Fragment>
    );
  }
}

WebSetting.propTypes = {
  rules: PropTypes.array
};
export default WebSetting
